// /hooks/useFetchMachineEmployeeList.js
import { useEffect, useMemo, useState } from "react"
import { doc, onSnapshot } from "firebase/firestore"
import { db } from "../firebase/config"

export default function useFetchMachineEmployeeList(machine) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)

  // Normalize "viva" -> "Viva"
  const key = useMemo(() => {
    if (!machine || typeof machine !== "string") return null
    return machine.charAt(0).toUpperCase() + machine.slice(1)
  }, [machine])

  useEffect(() => {
    setLoading(true)
    setError(null)
    const ref = doc(db, "settings", "employeeList")
    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (!snap.exists()) {
          setData(null)
          setError(new Error("settings/employeeList not found"))
          setLoading(false)
          return
        }
        setData(snap.data() || {})
        setLoading(false)
      },
      (err) => {
        setError(err)
        setLoading(false)
      }
    )
    return () => unsub()
  }, [])

  // Produce AntD Select options for the requested machine
  const options = useMemo(() => {
    if (!data || !key) return []
    const raw = data[key] || []
    // Support arrays of strings OR {label, value} objects
    return raw.map((item) =>
      typeof item === "string"
        ? { label: item, value: item }
        : { label: item.label ?? item.value, value: item.value ?? item.label }
    )
  }, [data, key])

  return { options, loading, error }
}
